import { apiClient } from '@copro/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function deleteQuoteGroup(groupId: string) {
  const { error } = await apiClient
    .from('quote_comparison_groups')
    .delete()
    .eq('id', groupId);

  if (error) {
    throw error;
  }
}

export function useDeleteQuoteGroup() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: deleteQuoteGroup,
    onSuccess: (_data, groupId) => {
      queryClient.invalidateQueries({ queryKey: keys.groupsList(currentSpace!.id) });
      queryClient.removeQueries({ queryKey: keys.group(groupId) });
      enqueueSnackbar('Comparaison supprimée.', 'success');
    },
  });
}
